import { DisplayValue, isNullOrUndefined } from '@adaptiva/core/common';
import { EFeedType, EPlatform, ETargetType, EUpdateType, EWhoAmI, GeneralProperties, IsMacOrLinuxPipe, MetadataSerialization } from '@adaptiva/metadata/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-general-properties',
	templateUrl: './general-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralPropertiesComponent extends BaseAuthoringPropertiesComponent<GeneralProperties> implements AfterViewInit {

	public override readonly propertyConstructor: MetadataSerialization.Deserializable<GeneralProperties> = GeneralProperties;

	public readonly updateTypeOptions: DisplayValue<EUpdateType>[] = [
		new DisplayValue('Security Update', EUpdateType.SECURITY_UPDATE),
		new DisplayValue('Update Rollup', EUpdateType.UPDATE_ROLLUP),
		new DisplayValue('Minor Feature Update', EUpdateType.MINOR_FEATURE_UPDATE),
		new DisplayValue('Major Feature Update', EUpdateType.MAJOR_FEATURE_UPDATE),
		new DisplayValue('Service Pack', EUpdateType.SERVICE_PACK),
		new DisplayValue('Bug Fix', EUpdateType.BUG_FIX),
	];

	public readonly targetTypeOptions: DisplayValue<ETargetType>[] = [
		new DisplayValue('Software', ETargetType.SOFTWARE),
		new DisplayValue('BIOS', ETargetType.BIOS),
		new DisplayValue('Driver', ETargetType.DRIVER),
		new DisplayValue('OS', ETargetType.OS),
	];

	// eslint-disable-next-line @typescript-eslint/naming-convention
	public readonly whoAmIOptions: DisplayValue<EWhoAmI>[] = [
		new DisplayValue<EWhoAmI>('Adaptiva 3rd Party', EWhoAmI.ADAPTIVA_3RD_PARTY),
		new DisplayValue<EWhoAmI>('Adaptiva WSUS', EWhoAmI.ADAPTIVA_WSUS),
		new DisplayValue<EWhoAmI>('Adaptiva Commercial', EWhoAmI.ADAPTIVA_COMMERCIAL),
		new DisplayValue<EWhoAmI>('Adaptiva Line of Business', EWhoAmI.ADAPTIVA_LOB)
	];

	public readonly platformOptions: DisplayValue<EPlatform>[] = MetadataSerialization.getPossibleValues<GeneralProperties>(GeneralProperties, 'Platform');
	
	public readonly feedTypeOptions: DisplayValue<EFeedType>[] = MetadataSerialization.getPossibleValues<GeneralProperties>(GeneralProperties, 'FeedType');

	protected readonly isMacOrLinuxPipe: IsMacOrLinuxPipe = new IsMacOrLinuxPipe();

	protected readonly isMacOrLinux: WritableSignal<boolean> = signal(false);

	public override setObjectPropertyValue(_propertyName: string, _value: any): void {
		if (isNullOrUndefined(_value) || _value === '')
			_value = null;

		super.setObjectPropertyValue(_propertyName, _value);
	}

	protected setPlatform(_platform: EPlatform): void {
		this.setObjectPropertyValue('Platform', _platform);
	}

}
